
import { Component, Vue, Mixins } from 'vue-property-decorator';
const Words: Dictionary = {
  placeholder: 'ホテル名・地名から探す',
  history: '最近検索したキーワードから探す',
  keyword: '人気のキーワードから探す',
};
@Component
export default class BlockLine extends Vue {
  private words = Words;
}
